var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.hasErrors)?_c('small',{staticClass:"el-form-item__error"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e(),(_vm.readonly && _vm.tagFormatValue.length == 0)?_c('span',{staticClass:"field-tail"},[_vm._v("\n    "+_vm._s(_vm.inputValue)+"\n    "),_vm._t("append")],2):_vm._e(),(
      _vm.readonly &&
        _vm.tagFormatValue.constructor == Array &&
        _vm.tagFormatValue.length > 0
    )?_c('span',_vm._l((_vm.tagFormatValue),function(label,index){return _c('span',{key:index},[_vm._v(_vm._s(label))])}),0):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }